import { useDispatch as ReduxUseDispatch } from 'react-redux';
import { ThunkDispatch } from 'redux-thunk';
import { Action } from 'redux';
import { RootState } from '../../reducers';

export type ReduxDispatch = ThunkDispatch<RootState, any, Action>;
export function useDispatch(): ReduxDispatch {
  return ReduxUseDispatch<ReduxDispatch>();
}
export default useDispatch;
